import { atom } from 'jotai';
export var servicesAtom = atom({
    list: [],
    currentService: null,
    notes: [],
});
export var voipAtom = atom({});
